export enum GeoLocationNameId {
  ID = 'id',
  LONGITUDE = 'longitude',
  LATITUDE = 'latitude',
  CREATED_AT = 'createdAt',
}
